export default "__VITE_ASSET__CIzRu48m__"